import { getUserProperties } from "./userProperties";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export const getPrimeUrl = (path: `/${string}`): string => {
  const base = `${process.env.NEXT_PUBLIC_GOI_PRIME_URL}${path}`;

  if (typeof window === "undefined") return base;

  const userProps = getUserProperties();
  const separator = base.includes("?") ? "&" : "?";
  const params = UTM_KEYS.filter((key) => userProps[key] && !base.includes(key))
    .map((key) => `${key}=${encodeURIComponent(userProps[key])}`)
    .join("&");

  return params ? `${base}${separator}${params}` : base;
};
